import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import FormfacadeEmbed from "@formfacade/embed-react";
const JoinUs = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        birthDate: '',
        facebookLink: '',
        classLevel: '',
        whyCreativeLab: ''
    });

    const classOptions = [
        'L1 CS', 'L1 IRS', 'L1 SE',
        'L2 CS', 'L2 IRS', 'L2 SE', 
        'L3 CS', 'L3 IRS', 'L3 SE',
        '1 ING', '2 ING IDL', '2 ING IDISC', '2 ING ISEOC',
        '3 ING IDL', '3 ING IDISC', '3 ING ISEOC',
        'M1', 'M2'
    ];

    // Input sanitization function
    const sanitizeInput = (input) => {
        if (typeof input !== 'string') return input;
        return input
            .trim()
            .replace(/[<>]/g, '') // Remove potential HTML tags
            .replace(/javascript:/gi, '') // Remove javascript: protocol
            .replace(/on\w+=/gi, '') // Remove event handlers
            .substring(0, 1000); // Limit length
    };

    // Email validation
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Phone validation
    const isValidPhone = (phone) => {
        const phoneRegex = /^[\+]?[0-9\s\-\(\)]{8,15}$/;
        return phoneRegex.test(phone);
    };

    // URL validation for Facebook link
    const isValidUrl = (url) => {
        if (!url) return true; // Optional field
        try {
            new URL(url);
            return url.includes('facebook.com') || url.includes('fb.com');
        } catch {
            return false;
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = sanitizeInput(value);
        setFormData(prev => ({
            ...prev,
            [name]: sanitizedValue
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate all required fields
        if (!formData.firstName || !formData.lastName || !formData.email || 
            !formData.phone || !formData.birthDate || !formData.classLevel || 
            !formData.whyCreativeLab) {
            alert('Please fill in all required fields.');
            return;
        }

        // Validate email format
        if (!isValidEmail(formData.email)) {
            alert('Please enter a valid email address.');
            return;
        }

        // Validate phone format
        if (!isValidPhone(formData.phone)) {
            alert('Please enter a valid phone number.');
            return;
        }

        // Validate Facebook URL if provided
        if (formData.facebookLink && !isValidUrl(formData.facebookLink)) {
            alert('Please enter a valid Facebook profile URL.');
            return;
        }

        // Validate birth date (must be at least 16 years old)
        const birthDate = new Date(formData.birthDate);
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear();
        if (age < 16) {
            alert('You must be at least 16 years old to join Creative Lab.');
            return;
        }

        try {
            // Prepare the data for the backend
            const applicationData = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                birthDate: formData.birthDate,
                facebookLink: formData.facebookLink || null,
                classLevel: formData.classLevel,
                whyCreativeLab: formData.whyCreativeLab
            };

            console.log("Submitting application:", applicationData);

            // Send data to backend
            const response = await fetch('http://localhost:8080/candidate-application/applications', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(applicationData)
            });

            if (response.ok) {
                const result = await response.json();
                console.log("Application submitted successfully:", result);
                navigate('/JoinSuccess');
            } else {
                const errorData = await response.json();
                console.error("Error submitting application:", errorData);
                alert(`Failed to submit application: ${errorData.message || 'Unknown error'}`);
            }
        } catch (error) {
            console.error("Network error:", error);
            alert('Failed to submit application. Please check your internet connection and try again.');
        }
    };

    return (
        <div>
            <Header />
            <div className="page-heading header-text">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Join Creative Lab</h1>
                            <span>Become part of our tech community and start your journey with us</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="callback-form contact-us">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-heading">
                                <h2>Join our <em>community</em></h2>
                                <span>BECOME PART OF OUR TECH FAMILY TODAY!!</span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="contact-form">
                                
                            <FormfacadeEmbed

                                formFacadeURL="https://formfacade.com/include/109344400973647724051/form/1FAIpQLSdfj8B6krI4t4CEujdSzROQTtDTxhvkY39ktU0ZWE1EL-WVqQ/classic.js/?div=ff-compose"

                                onSubmitForm={() => console.log('Form submitted')}

                    />
                                    </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default JoinUs;
